/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import moment from 'moment'
import {
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {
  DivFormTitle,
  ExpandPainelItemContainer,
  ExpandPainelItemLabel,
} from "./styles";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";

const LogModal = (props) => {
  const log = useSelector((state) => state.logs.log);
  const loading = useSelector((state) => state.logs.loadingLog);

  return (
    <div style={styles.container}>
      {loading ? (
        <div style={styles.spinner}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <DivFormTitle style={styles.headerContainer}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "1.25rem",
              }}
            >
              DETALHES DO LOG
            </div>
            <IconButton onClick={props.closeModal} color="inherit" size="large">
              <CloseIcon />
            </IconButton>
          </DivFormTitle>
          <div style={styles.bodyContainer}>
            <ExpandPainelItemContainer>
              <ExpandPainelItemLabel>Usuário:</ExpandPainelItemLabel>
              {log.user ? log.user.name : (log.apiKey ? 'apiKey' : 'public')}
            </ExpandPainelItemContainer>
            <ExpandPainelItemContainer>
              <ExpandPainelItemLabel>Função:</ExpandPainelItemLabel>
              {log.role ? log.role : '-'}
            </ExpandPainelItemContainer>
            {
              !isEmpty(log.positions) && 
              <ExpandPainelItemContainer>
                <ExpandPainelItemLabel>Cargo:</ExpandPainelItemLabel>
                {log.positions.map(position => position.name)}
              </ExpandPainelItemContainer>
            }
            {
              !isEmpty(log.documentTypes) && 
              <ExpandPainelItemContainer>
                <ExpandPainelItemLabel>Tipo:</ExpandPainelItemLabel>
                {log.documentTypes.map(documentType => documentType.name)}
              </ExpandPainelItemContainer>
            }
			      <ExpandPainelItemContainer>
              <ExpandPainelItemLabel>Tabela afetada:</ExpandPainelItemLabel>
              {log.table}
            </ExpandPainelItemContainer>
			      <ExpandPainelItemContainer>
              <ExpandPainelItemLabel>Tipo de operação:</ExpandPainelItemLabel>
              {log.operationName}
            </ExpandPainelItemContainer>
            <ExpandPainelItemContainer>
              <ExpandPainelItemLabel>Nome:</ExpandPainelItemLabel>
              {!isEmpty(log.documentId) && log.documentId.name}
            </ExpandPainelItemContainer>
            <ExpandPainelItemContainer>
              <ExpandPainelItemLabel>Data da operação:</ExpandPainelItemLabel>
              {moment(log.createdAt).format('DD/MM/YYYY')}
            </ExpandPainelItemContainer>
            { 
              (log.file.documentName && log.file.fileName) ? (
                <>
                  <ExpandPainelItemContainer>
                    <ExpandPainelItemLabel>Documento verificado:</ExpandPainelItemLabel>
                    {log.file.documentName}
                  </ExpandPainelItemContainer>
                  <ExpandPainelItemContainer>
                    <ExpandPainelItemLabel>Arquivo verificado:</ExpandPainelItemLabel>
                    {log.file.fileName}
                  </ExpandPainelItemContainer>
                </>
              )
              : (
                <>
                  <ExpandPainelItemContainer>
                    <ExpandPainelItemLabel>Duração:</ExpandPainelItemLabel>
                    {log.operationDuration}
                  </ExpandPainelItemContainer>
                  <ExpandPainelItemContainer>
                    <ExpandPainelItemLabel>Identificador da chamada:</ExpandPainelItemLabel>
                    {log.requestDetails.id}
                  </ExpandPainelItemContainer>
                  <ReactDiffViewer
                    oldValue={log.documentBefore == 'null' ? '' : JSON.stringify(JSON.parse(log.documentBefore), null, '\t')}
                    newValue={log.documentAfter == 'null' ? '' : JSON.stringify(JSON.parse(log.documentAfter), null, '\t')}
                    splitView={false}
                    compareMethod={DiffMethod.SENTENCES}
                    showDiffOnly={true}
                  />
                </>
              )
            }
          </div>
        </>
      )}
    </div>
  );
};

const styles = {
  container: {
    width: "50rem",
    height: "100%",
  },
  headerContainer: {
    height: "5rem",
    padding: "0 1rem 0 2rem",
    backgroundColor: "#008100",
    color: "#fff",
  },
  bodyContainer: {
    height: "calc(100% - 10rem)",
    padding: "1rem 2rem",
    overflowY: "auto",
    borderTop: "1px solid #ccc",
    borderBottom: "1px solid #ccc",
  },
  spinner: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    top: "-5px",
    opacity: "1",
    zIndex: 2,
  },
};

export default LogModal;
